import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Link,
  Route,
  useParams,
  Switch,
} from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import FeeCard from "./FeeCard";
import FeeReceipt from "./FeeReceipt";
import PaymentHistory from "./PaymentHistory";
import FeeCollection from "./FeeCollection";
import MdlSelectSingleStudent from "../dialog/MdlSelectSingleStudent";

const PaymentStatus = (onComplete) => {
  const token = localStorage.getItem("token");
  const loggedIn = token !== null;

  const { transaction_id, student_id, session_id, session_name } = useParams();
  const [isOpenStudentSelector, setIsOpenStudentSelector] = useState(false);

  const [state, setState] = useState({
    isOpen: false,
    loggedIn,
    Loading: false,
    status: false,
    TRANSACTION_ID: "",
    STUDENT_ID: "",
    SESSION_ID: "",
    SESSION_NAME: "",
  });

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      TRANSACTION_ID: transaction_id,
      STUDENT_ID: student_id,
      SESSION_ID: session_id,
      SESSION_NAME: session_name,
    }));
  }, [transaction_id, student_id, session_id, session_name]);

  // methods
  const HandleShow = () => {
    setIsOpenStudentSelector(!isOpenStudentSelector);
  };

  const HandleClose = () => {
    setIsOpenStudentSelector(false);
  };

  const HandleSelectedStudent = (
    student_id,
    selected_item,
    session_id,
    session_name
  ) => {
    setIsOpenStudentSelector(false);
    onComplete(student_id, selected_item, session_id, session_name);
  };

  return (
    <Router>
      <Switch>
        <Route
          path={
            "/AdminMain/PaymentStatus/:student_id/:session_id/:session_name/:transaction_id"
          }
          exact
          render={() => {
            return (
              <div className="content">
                <div className="content-header">
                  <div className="leftside-content-header">
                    <ul className="breadcrumbs">
                      <li>
                        <i className="fa fa-home" aria-hidden="true" />
                        <a href="#"> Payment Status </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="animated fadeInUp bg_page_white_rounded"
                  style={{ "--mMargin": "50px" }}
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 gravity_center">
                      <div className="img-checked">
                        <img
                          src="https://images.vexels.com/media/users/3/157931/isolated/preview/604a0cadf94914c7ee6c6e552e9b4487-curved-check-mark-circle-icon-by-vexels.png"
                          alt="check image"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row gravity_center">
                    <h3 className="text-center mb-100 text-success">
                      {" "}
                      Collected Successfully{" "}
                    </h3>
                  </div>

                  <div className="row gravity_center">
                    <div className="col-sm-3">
                      <div
                        className="bg_card_primary gravity_center"
                        style={{
                          width: "100%",
                          height: "40px",
                          fontSize: "16px",
                        }}
                      >
                        <Link
                          to={`/AdminMain/FeeReceipt/${state.TRANSACTION_ID}/${state.STUDENT_ID}/${state.SESSION_ID}`}
                          className="text-white"
                        >
                          Get Fee Receipt
                        </Link>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12">
                      <hr />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <div
                        className="bg_card_primary gravity_center"
                        style={{
                          width: "100%",
                          height: "40px",
                          fontSize: "16px",
                        }}
                      >
                        <Link to={"/AdminMain/FeeCard"} className="text-white">
                          Fee Card
                        </Link>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div
                        className="bg_card_primary gravity_center"
                        style={{
                          width: "100%",
                          height: "40px",
                          fontSize: "16px",
                        }}
                      >
                        <Link
                          to={`/AdminMain/PaymentHistory/${state.STUDENT_ID}/${state.SESSION_ID}/${encodeURIComponent(state.SESSION_NAME || state.SESSION_ID || "Session")}`}
                          className="text-white"
                        >
                          Payment History
                        </Link>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div
                        className="bg_card_primary gravity_center text-white cursor"
                        style={{
                          width: "100%",
                          height: "40px",
                          fontSize: "16px",
                        }}
                        onClick={HandleShow}
                      >
                        Collect Another
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div
                        className="bg_card_primary gravity_center"
                        style={{
                          width: "100%",
                          height: "40px",
                          fontSize: "16px",
                        }}
                      >
                        <Link
                          to={"/AdminMain/FeeCollection"}
                          className="text-white"
                        >
                          Back To Fee Collection{" "}
                        </Link>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-12">
                      <hr />
                    </div>
                  </div>
                </div>
                {isOpenStudentSelector === true ? (
                  <MdlSelectSingleStudent
                    action={HandleClose}
                    action2={HandleSelectedStudent}
                  ></MdlSelectSingleStudent>
                ) : (
                  ""
                )}
              </div>
            );
          }}
        />
        <Route
          path="/AdminMain/FeeReceipt/:transaction_id/:student_id/:session_id"
          component={FeeReceipt}
        />
        <Route
          path="/AdminMain/PaymentHistory/:student_id/:session_id/:session_name"
          component={PaymentHistory}
        />
        <Route path="/AdminMain/FeeCard" component={FeeCard} />
        <Route path="/AdminMain/FeeCollection" component={FeeCollection} />
      </Switch>
    </Router>
  );
};

export default PaymentStatus;
